// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KI0D","buttons":"styles_buttons__10fto"};